import styled from 'styled-components';

export const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 23px;
  border-radius: 8px;
  background: #E9E9E9;
  align-items: center;
  flex: 1;
`;

export const CardTitle = styled.div`
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
`;

export const DatesWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 6px;
  align-items: center;
`;